import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringUtilsService {
  static convertToHTMLCharset(symbol: string): string {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = symbol;
    return textArea.value;
  }

  convertStringToBase64Encoding(stringToBeConeverted: string): string {
    return btoa(
      encodeURIComponent(stringToBeConeverted).replace(
        /%([0-9A-F]{2})/g,
        function encodeUniCode(match, p1: string): string {
          return String.fromCharCode(parseInt('0x' + p1, 16));
        }
      )
    );
  }
}
